module.exports = __webpack_public_path__ + "img/001.29637a9d.png";